<template>
    <div>
        <div class="col-md-12">
          <boton-atras :nombre_ruta="'Menu'"/>
        </div>
        <div class="container text-center mb-5">
          <h1 class="bold300 text-uppercase" style=" font-weight:500;">Informes de Finanzas Públicas</h1>
        </div>
        <div class="container" v-if="data">
          <div class="row">
              <div class="col-md-6" v-for="(item, i) in data" :key="i" >
                <router-link :to="{name: routeo(item.id)}">
                  <cardsMenu  :card="item"/>
                </router-link>
              </div>
          </div>
          <span v-html="fecha_actualizacion"></span>
        </div>
    </div>
</template>
<script>
import mapFun from '@/common/map-fn-types.js';
import InformeFinanzasPub from "@/services/rendicionDeCuentas/informeFinanzaPub/informeFinanzaPub.js";
const _serviciosInformeFinanzasPub = new InformeFinanzasPub();
import mixin from '@/mixins/mixin.js'
import cardsMenu from '../../../components/cardsMenu.vue';
import botonAtras from '../../button-atras.vue';
import DateFormat from "@/mixins/dateFormatMixin.js";


export default {
    components: {cardsMenu, botonAtras},
    data() {
        return {
          data: [],
          fecha_actualizacion:'',
        };
    },
    async created() {
        window.scrollTo(0, 0);
        await this.getMenuInformeFinanzasPub();
    },
    mixins: [mixin, DateFormat],
    methods: {
        async getMenuInformeFinanzasPub() {
            try {
                const response = await _serviciosInformeFinanzasPub.getMenuInformeFinanzaPub(mapFun.informeFinanzasPubMenu);
                this.data = response.data;
                let fecha_texto = this.data[this.data.length - 1].fecha_actualizacion;
                this.fecha_actualizacion = this.DateFormatText(fecha_texto);
            } catch (error) {
                console.log('error', error.message);
            }
        },
        routeo(n){
          switch(n) {
            case 1: return "IFP-Evolucion-gasto-publico";
            case 2: return "IFP-Informes-Contables";
            case 3: return "IFP-Proceso-Contratacion-Deuda-Publica";
            case 4: return "IFP-Elementos-Programaticos";
            case 5: return "IFP-Entes-Publicos";
            default: break;
          }
        },
    }
}
</script>
